import { apiFetch } from "@core/http";
import type { components } from "@core/types/openapi";

// SPEC-203 §4 (resolución humana 2026-09-19): la pestaña Mantenimientos de la
// ficha del miembro lista los mantenimientos de *todos* sus vehículos, cada
// uno con su vehículo identificado — `MemberMaintenance` es el `Maintenance`
// existente compuesto con `vehicle` (contrato, ver `mnt-http`). Solo lectura:
// el registro y la edición siguen viviendo en `vehicles/MaintenancePanel.tsx`,
// sobre el vehículo concreto.
export type MemberMaintenance = components["schemas"]["MemberMaintenance"];

const memberMaintenancesBase = (memberId: string) =>
  `/v1/portal/members/${encodeURIComponent(memberId)}/maintenances`;

export const listMemberMaintenances = (memberId: string) =>
  apiFetch<MemberMaintenance[]>(memberMaintenancesBase(memberId));
